import { useState, useEffect } from 'react';
import httpclient from 'libs/Axios';

export const useSocialHubStatus = (isUpsertLoading: boolean) => {
    const [socialHubStatus, setSocialHubStatus] = useState<object>({});
    const [loader, setLoader] = useState<boolean>(false);

    const requestSocialHubStatus = async () => {
        try {
            setLoader(true);
            const response = await httpclient().get(`/comm/socialHub/status`);
            setLoader(false);
            const data = response?.data?.data || {};
            setSocialHubStatus(data);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        try {
            if (!isUpsertLoading) {
                requestSocialHubStatus();
            }
        } catch (err) {
        }
    }, [isUpsertLoading]);

    return {
        socialHubStatus,
        loader,
        requestSocialHubStatus
    };
};
